import React from 'react';
import { Check, CheckCircle2 } from 'lucide-react';
export function BeneficiosIdeal() {
  return <section id="beneficios" className="py-5 sm:py-16 bg-[#0a1628] border-t border-gray-800" data-id="element-13">
      <div className="max-w-5xl mx-auto px-3 sm:px-6" data-id="element-14">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 sm:gap-8" data-id="element-15">
          {/* Left Column: Ideal Para */}
          <div className="bg-[#1e293b]/60 p-3 sm:p-6 rounded-xl border border-gray-700/50" data-id="element-16">
            <h3 className="text-base sm:text-2xl font-bold text-white mb-3 sm:mb-6 border-b border-gray-700 pb-2" data-id="element-17">
              Este kit es ideal para:
            </h3>
            <ul className="space-y-1.5 sm:space-y-3" data-id="element-18">
              {['Docentes de Proyecto Organizacional', 'Profesores de Gestión y Organizaciones', 'Docentes que trabajan en varias instituciones', 'Profesores de 4°, 5° y 6° año', 'Educadores que necesitan una estructura clara para todo el año', 'Profesores que quieren trabajar proyectos reales en el aula'].map((item, index) => <li key={index} className="flex items-start" data-id="element-19">
                  <div className="flex-shrink-0 bg-blue-500/20 rounded-full p-0.5 mr-2 mt-0.5" data-id="element-20">
                    <Check className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-blue-400" strokeWidth={3} data-id="element-21" />
                  </div>
                  <span className="text-xs sm:text-base text-gray-200" data-id="element-22">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          {/* Right Column: Beneficios */}
          <div className="bg-[#1e293b]/60 p-3 sm:p-6 rounded-xl border border-gray-700/50" data-id="element-23">
            <h3 className="text-base sm:text-2xl font-bold text-white mb-3 sm:mb-6 border-b border-gray-700 pb-2" data-id="element-24">
              Beneficios del Kit
            </h3>
            <ul className="space-y-1.5 sm:space-y-3" data-id="element-25">
              {['Sistema completo organizado por módulos', 'Estructura clara para trabajar la materia durante todo el año', 'Desarrollo completo de proyectos organizacionales', 'Diagnóstico y análisis de organizaciones', 'Planificación estratégica aplicada', 'Gestión real de proyectos', 'Ahorro real de tiempo en planificación'].map((item, index) => <li key={index} className="flex items-start" data-id="element-26">
                  <div className="flex-shrink-0 bg-green-500/20 rounded-full p-0.5 mr-2 mt-0.5" data-id="element-27">
                    <CheckCircle2 className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-[#16a34a]" strokeWidth={3} data-id="element-28" />
                  </div>
                  <span className="text-xs sm:text-base text-gray-200 font-medium" data-id="element-29">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}